import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';

import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { Identifyable } from '~core/abstractions/identifyable';
import { FormControlPipe } from '~core/pipes/form-control.pipe';

@Component({
    selector: 'arc-checkbox-column',
    templateUrl: './checkbox-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatCheckbox, ReactiveFormsModule, FormControlPipe]
})
export class CheckboxColumnComponent<T extends Identifyable<TId>, TId = number> extends BaseColumnComponent<T, TId> implements OnInit {
    override ngOnInit(): void {
        super.ngOnInit();
        this.classes = 'w-full';
    }
}
